import { render } from "./RatesList.vue?vue&type=template&id=53b753c6"
import script from "./RatesList.vue?vue&type=script&lang=js"
export * from "./RatesList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__